import axios from "axios";
import { translateError } from "../locales/errors";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rox_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.startsWith("/auth/") && localStorage.getItem("rox_token")) {
      localStorage.removeItem("rox_token");
      if (!window.location.pathname.startsWith("/connexion")) window.location.assign("/connexion");
    }
    return Promise.reject(error);
  }
);

export const imgSrc = (url) => (url && url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export function errorMessage(e) {
  const lang = localStorage.getItem("rox_lang") || "fr";
  const detail = e?.response?.data?.detail;
  if (!detail) return translateError(e?.response ? "Une erreur est survenue." : "Connexion au serveur impossible.", lang);
  if (typeof detail === "string") return translateError(detail, lang);
  if (Array.isArray(detail)) return translateError("Données invalides.", lang);
  return translateError(detail?.msg || String(detail), lang);
}
